<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="m18.94 14.85.02.07a5.77 5.77 0 0 1-1.75 4.55c-1.2 1.12-2.87 1.68-5 1.68-2.14 0-3.88-.69-5.21-2.06a7.28 7.28 0 0 1-2-5.32v-3.53c0-2.16.65-3.93 1.95-5.31 1.3-1.4 3-2.08 5.08-2.08 2.2 0 3.92.56 5.16 1.68a5.82 5.82 0 0 1 1.8 4.61l-.01.07H15.5c0-1.18-.28-2.07-.84-2.7-.57-.61-1.43-.93-2.62-.93-1.07 0-1.92.43-2.55 1.3a5.54 5.54 0 0 0-.93 3.32v3.55c0 1.36.32 2.47 1 3.34.65.86 1.54 1.3 2.67 1.3s1.94-.3 2.47-.9c.54-.61.8-1.5.8-2.68h3.45l-.02.04Z"
    />
  </svg>
</template>
<script>
export default {};
</script>
